export enum ColorScheme {
  lightest = "var(--color-brand-lightest)",
  light = "var(--color-brand-light)",
  medium = "var(--color-brand-medium)",
  dark = "var(--color-brand-dark)",
  darkest = "var(--color-brand-darkest)",
}

export enum SSColors {
  apprentice = "var(--official-cell-bg-apprentice)",
  emptyOfficial = "var(--official-cell-bg-emptyOfficial)",
  rejectedAppointment = "var(--official-cell-bg-rejectedAppointment)",
}

export enum StatusColors {
  red = "#EBAFAF",
  green = "#A8D199",
  yellow = "#F8EBB7",
  grey = "#E8E8E8",
}

export namespace StatusColors {
  export function toBorderColor(color: StatusColors): string {
    switch (color) {
      case StatusColors.green:
        return "#729D62";
      case StatusColors.yellow:
        return "#D6C68F";
      case StatusColors.red:
        return "#E29595";
      case StatusColors.grey:
        return "#C7C7C7";
      default:
        return "black";
    }
  }
}
